"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TextStackContent = void 0;
var _react = _interopRequireDefault(require("react"));
var _coreBaseProps = require("@legacy-vfuk/core-base-props");
var _coreTextStack = _interopRequireDefault(require("@legacy-vfuk/core-text-stack"));
var _coreSimpleGrid = _interopRequireDefault(require("@legacy-vfuk/core-simple-grid"));
var _coreParagraph = _interopRequireDefault(require("@legacy-vfuk/core-paragraph"));
var Styled = _interopRequireWildcard(require("./styles/TextStackContent.style"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var TextStackContent = function TextStackContent(_ref) {
  var primaryTextStack = _ref.primaryTextStack,
    secondaryTextStack = _ref.secondaryTextStack,
    subText = _ref.subText,
    verticalJustification = _ref.verticalJustification,
    justify = _ref.justify,
    inverse = _ref.inverse,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 2 : _ref$size,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
    textStackSlotTheme = _ref.textStackSlotTheme,
    dataSelectorPrefix = _ref.dataSelectorPrefix;
  var _ref2 = inverse ? textStackSlotTheme.appearance[appearance].inverse : textStackSlotTheme.appearance[appearance],
    textStackAppearance = _ref2.textStackAppearance,
    textStackLevel = _ref2.textStackLevel,
    inverseTextStack = _ref2.inverseTextStack;
  var textStackProps = {
    appearance: textStackAppearance,
    level: textStackLevel,
    inverse: inverseTextStack,
    size: size,
    justify: justify
  };
  return /*#__PURE__*/_react["default"].createElement(Styled.TextStackSlotContent, {
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix)
  }, /*#__PURE__*/_react["default"].createElement(_coreSimpleGrid["default"], {
    columns: {
      sm: secondaryTextStack ? 2 : 1
    },
    spacing: 6,
    verticalAlign: verticalJustification
  }, /*#__PURE__*/_react["default"].createElement(_coreTextStack["default"], _extends({}, primaryTextStack, textStackProps, {
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'primary-text-stack')
  })), secondaryTextStack && /*#__PURE__*/_react["default"].createElement(_coreTextStack["default"], _extends({}, secondaryTextStack, textStackProps, {
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'secondary-text-stack')
  }))), /*#__PURE__*/_react["default"].createElement(_coreParagraph["default"], {
    size: 1,
    noMargin: true,
    inverse: inverse,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'sub-text')
  }, subText));
};
exports.TextStackContent = TextStackContent;
TextStackContent.displayName = "TextStackContent";
var _default = TextStackContent;
exports["default"] = _default;
//# sourceMappingURL=TextStackContent.js.map